import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import ROUTES from '../../constants/routes';

const PrivateRoute = ({ isAuthenticated, hasSecurityQuestions, ...rest }) => {
  const otherProps = { ...rest }
  if (!isAuthenticated) {
    return <Redirect to={ROUTES.login.route} />
  } else {
    if (!hasSecurityQuestions) {
      if (otherProps.location.pathname !== ROUTES.setSecurityQuestions.route) {
        return <Redirect to={ROUTES.setSecurityQuestions.route} />
      } else {
        return <Route {...rest} />
      }
    } else {
      return <Route {...rest} />
    }
  }
};

const mapStateToProps = ({ authentication }) => {
  return {
    isAuthenticated: authentication.isAuthenticated,
    hasSecurityQuestions: authentication.hasSecurityQuestions
  };
};

export default connect(mapStateToProps)(PrivateRoute);
